import { IGiaoVienActionTypes } from "../../action-types/category/IGiaoVienActions";
import { IGiaoVienReducer } from "../../reducer-model/category/IGiaoVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IGiaoVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  giaoViens: [],
};
export const giaoVienReducer = (
  state: IGiaoVienReducer = iniState,
  action: IGiaoVienActionTypes
): IGiaoVienReducer => {
  switch (action.type) {
    case "GIAO_VIEN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "GIAO_VIEN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        giaoViens: action.payload,
      };
    case "GIAO_VIEN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GIAO_VIEN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        giaoVienEditing: action.payload,
      };
    case "GIAO_VIEN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "GIAO_VIEN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "GIAO_VIEN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "GIAO_VIEN_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GIAO_VIEN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "GIAO_VIEN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "GIAO_VIEN_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
